export const WORKFLOW_OPTIONS = [
  { value: "1", label: "1 - Operations" },
  { value: "2", label: "2 - Operations, create deliverables" },
  { value: "3", label: "3 - Drafting" },
  { value: "4", label: "4 - Registered surveyor" },
  { value: "5", label: "5 - Operations" },
  { value: "6", label: "6 - Operations" },
  { value: "7", label: "7 - Registered surveyor" },
  { value: "8", label: "8 - Searches" }
]

export const FILE_RELEASE_OPTIONS = [
  { value: "", label: "None" },
  { value: "1", label: "1 - Signed plans, sketch, report, photos, drafted documents and searches" },
  { value: "2", label: "2 - Signed plans, sketch and RS report" },
  { value: "3", label: "3 - Administration sheets and drafted documents" },
  { value: "4", label: "4 - PPN and 88B/88E" }
]

export const FIELD_WORK_UPLOAD_OPTIONS = [
  { value: "", label: "Same day" },
  { value: "COB Next Day", label: "COB next day" }
]

export const STARTING_DIVISION_OPTIONS = [
  { value: "", label: "Not set" },
  { value: "301", label: "Operations" },
  { value: "302", label: "Drafting" },
  { value: "303", label: "Registered Surveyor" }
]

export const OPERATIONS_CAN_BOOK_OPTIONS = [
  { value: "", label: "Not set" },
  { value: "304", label: "Yes" },
  { value: "305", label: "No" }
]

export function workflowLabel(value) {
  if (!value) return "-"
  const match = WORKFLOW_OPTIONS.find(option => option.value === String(value))
  return match ? match.label : value
}

export function withCurrentOption(options, current) {
  if (current == null || current === "") return options
  const value = String(current)
  if (options.some(option => option.value === value)) return options
  return [{ value, label: value }, ...options]
}

export function productFormFromAttributes(attributes = {}) {
  return {
    name: attributes.name || "",
    code: attributes.code || "",
    description: attributes.description || "",
    scopeOfWork: attributes.scopeOfWork || "",
    workflow: attributes.workflow || "",
    startingDivision: attributes.startingDivision == null ? "" : String(attributes.startingDivision),
    estimatedHours: attributes.estimatedHours ?? "",
    clientDueDateCount: attributes.clientDueDateCount || "",
    draftingDueDateCount: attributes.draftingDueDateCount || "",
    fieldWorkUploadDaysCount: attributes.fieldWorkUploadDaysCount || "",
    defaultFileRelease: attributes.defaultFileRelease || "",
    operationsCanBookRebook: attributes.operationsCanBookRebook == null ? "" : String(attributes.operationsCanBookRebook),
    activeFlag: attributes.activeFlag ?? true,
    selectable: attributes.selectable ?? true,
    dbydRequired: Boolean(attributes.dbydRequired)
  }
}

export function apiErrorMessage(error, fallback) {
  const details = error?.response?.data?.errors
  if (Array.isArray(details) && details.length) {
    return details.map(item => item.detail || item).filter(Boolean).join(", ")
  }
  return fallback
}
